import * as auth from '../auth'
import {onStatus} from './helpers'
import {cookiePost, get, monolithPost, post} from './fetch'
import services from '../config/services'

// JWT

// XXX: We make the lowercase here because the auth service does not yet
//  sanitize (read: "lowercase") all incoming email addresses like the
//  monolith does.
export const getJwt = (email, password) =>
  post(
    // no JWT yet (and no JWT required), so make a plain post
    `${services.AUTH_SERVICE_URL}/obtain-token`,
    {email: email.toLowerCase(), password},
  ).then(
    onStatus({
      OK: ({json: {token}}) => auth.setJwt(token),
      DEFAULT: ({status, statusText}) =>
        console.error(`Could not retrieve JWT token. Status: ${status} ${statusText}.`),
    }),
  )

// This is the CC 'Login As User' hack, which allows admins to click a button
//  in /admin/user to log in as a customer.
export const getJwtForLoginAsUser = (inf) =>
  get(`${services.AUTH_SERVICE_URL}/inf/${inf}`)
    .then(
      onStatus({
        OK: ({json: {key}}) => auth.setJwt(key),
        DEFAULT: ({status, statusText}) =>
          console.error(
            `Could not retrieve JWT token with inf ${inf}. Status: ${status} ${statusText}.`,
          ),
      }),
    )
    .catch((e) => console.error(e.message))

// Login

export const login = (email, password, location) =>
  cookiePost('/auth/login', {email, password, location})

// XXX: What the getUser call should look like (I'm guessing):
//
// export const getUser = (jwt, email, location) =>
//   monolithPost('/auth/user', {email, location}, {
//     headers: {
//       Authorization: `jwt ${jwt}`, // override built in JWT functionality
//     },
//   })
//  .then(onStatus({OK: shimRedirect}))

// Register

// When registering as a non-participant, the `date` and `type` properties
//  on json.event, will be `null`, which will overwrite the store
//  momentarily. Also, `name` will be incorrect. Both issues will resolve
//  themselves when refreshInitialState() kicks in.
// When registering as a participant, the `date`, `name`, and `type`
//  properties are vaild and essential to the dashboard working correctly.

export const register = (email, password, location) =>
  cookiePost('/auth/register', {email, password, location})

// Password Reset

export const resetPassword = (email) => monolithPost('/auth/reset', {email})
